import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import MarketBrandsPage from '@fuww/library/src/Layouts/MarketBrandsPage';
import { StyledListItem } from '@fuww/library/src/List/Styled';
import ListItemContent from '@fuww/library/src/List/List';
import { List } from '@fuww/library/src/List/index';
import withApollo from '../lib/apollo';
import marketBrandsConnectionQuery
  from '../lib/queries/products/marketBrandsConnectionQuery.graphql';
import Heading from '../components/Brands/Heading';
import withQuery from '../lib/withQuery';
import loadMore from '../lib/queries/loadMore';
import LoadMore from '../components/LoadMore';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Tabs from '../components/Tabs';
import debouncedReplaceRoute from '../lib/debouncedReplaceRoute';
import { useSiteContext } from '../components/SiteContext';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import replaceRoute from '../lib/replaceRoute';

const BrandsList = ({
  data, variables, fetchMore, loading, marketId,
}) => {
  const { marketBrandsConnection: { edges, pageInfo: { hasNextPage } } } = data;

  return (
    <>
      <List>
        {edges && edges.map(({
          node: {
            id, name,
          },
        }) => (
          <StyledListItem key={id} showDivider>
            <LinkAndAnchor
              route="products"
              params={{ marketId, brandIds: id }}
            >
              <ListItemContent
                title={name}
              />
            </LinkAndAnchor>
          </StyledListItem>
        ))}
      </List>
      <LoadMore
        loading={loading}
        hasNextPage={hasNextPage}
        fetchMore={() => loadMore({ variables })(
          data,
          'marketBrandsConnection',
          fetchMore,
        )}
      />
    </>
  );
};

BrandsList.propTypes = {
  fetchMore: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  variables: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    marketBrandsConnection: PropTypes.shape({
      pageInfo: PropTypes.shape({
        hasNextPage: PropTypes.bool,
      }),
      edges: PropTypes.arrayOf(
        PropTypes.shape({}),
      ),
    }),
  }).isRequired,
  marketId: PropTypes.number,
};

BrandsList.defaultProps = {
  marketId: null,
};

const BrandsListWithQuery = withQuery(BrandsList);

const BrandsPage = () => {
  const BRANDLIMIT = 10;
  const {
    query:
    { search: searchParameter, marketId: marketIdParameter },
  } = useRouter();

  const marketId = Number(marketIdParameter);
  const [search, setSearch] = useState(searchParameter || '');
  const { locale } = useSiteContext();

  const onChangeSearchTerm = ({ target: { value } }) => {
    setSearch(value);
    debouncedReplaceRoute(
      'market-brands',
      { marketId, search: value || null },
    );
  };

  const onClear = () => {
    setSearch('');
    replaceRoute('market-brands', { marketId });
  };

  return (
    <>
      <Heading marketId={marketId} tabs={<Tabs />} />
      <MarketBrandsPage
        keywords={search}
        onChange={onChangeSearchTerm}
        onClear={onClear}
      >
        <BrandsListWithQuery
          query={marketBrandsConnectionQuery}
          variables={{
            first: BRANDLIMIT,
            brandSearch: searchParameter,
            marketId,
            locales: [locale],
          }}
          errorMessage="Error loading brands"
          marketId={marketId}
        />
      </MarketBrandsPage>
    </>

  );
};

BrandsPage.getInitialProps = redirectRouteToDomain(
  'market-brands',
);

export default withApollo(BrandsPage);
